<template>
  <div class="banner">
    <img
      v-if="!imgList.length"
      class="img flex"
      src="https://imgcdn.hemiao100.com/hemiaoBase/TIM%E6%88%AA%E5%9B%BE20190903142717.png"
      alt
    />
    <el-carousel
      arrow="never"
      trigger="click"
      height="77px"
      v-if="imgList.length"
    >
      <el-carousel-item v-for="(v, i) in imgList" :key="i">
        <img class="img" :src="v.src" alt="图片广告" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss"></style>
